export { default } from "./Text.js";
